<template>
  <div class="printer">
    <PrinterList />
  </div>
</template>

<script>
// @ is an alias to /src
import PrinterList from "@/components/PrinterList.vue";

export default {
  name: "Printer",
  components: {
    PrinterList
  }
};
</script>
